import marquee1 from "~/assets/marquee/marquee1.webp";
import marquee2 from "~/assets/marquee/marquee2.webp";
import marquee3 from "~/assets/marquee/marquee3.webp";
import marquee4 from "~/assets/marquee/marquee4.webp";

export const marqueeImages = [marquee1, marquee2, marquee3, marquee4];
